// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { PropTypes } from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getLocator } from '../../../../../../../utils';
import style from '../SeoCopy.style';
import Espot from '../../../../../../common/molecules/Espot';

class SeoCopy extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  handleSeoCopyView = (e) => {
    this.setState({ isExpanded: e.target.checked });
  };

  countAndAppendDivTag = (htmlString) => {
    // Count the number of <div occurrences in the input string
    let updatedHtmlString = htmlString;
    // Count the number of <div and </div> occurrences in the input string
    const openingDivCount = (updatedHtmlString.match(/<div/g) || []).length;
    const closingDivCount = (updatedHtmlString.match(/<\/div>/g) || []).length;

    // Check if there are missing closing </div> tags
    if (openingDivCount > closingDivCount) {
      const missingDivTags = openingDivCount - closingDivCount;
      updatedHtmlString += '</div>'.repeat(missingDivTags);
    }
    return updatedHtmlString;
  };

  render() {
    const { copyBody, className, copyTitle, isStoreDetailsRedesignMobileEnabled } = this.props;
    const { isExpanded } = this.state;

    const READ_MORE = 'Read More+';
    const READ_LESS = 'Read Less-';

    const copyBodyNew = copyBody && this.countAndAppendDivTag(copyBody);
    return (
      <BodyCopy
        component="div"
        className={`${className} ${isExpanded && 'read-more-expanded'} seo-text`}
        tabIndex="0"
      >
        {isStoreDetailsRedesignMobileEnabled
          ? copyTitle && <h1 className="seo-title">{copyTitle}</h1>
          : copyTitle && (
              <BodyCopy
                className="title"
                fontSize="fs22"
                component="h1"
                color="text.primary"
                fontFamily="secondary"
                fontWeight="black"
                textAlign="center"
                data-locator={getLocator('seo_title')}
              >
                {copyTitle}
              </BodyCopy>
            )}
        {copyBody && (
          <BodyCopy
            className="body-copy"
            fontSize="fs14"
            component="div"
            color="text.primary"
            fontFamily="secondary"
            fontWeight="regular"
            textAlign="center"
            data-locator={getLocator('seo_body')}
          >
            <Espot richTextHtml={copyBodyNew} />
          </BodyCopy>
        )}
        {copyBody && copyBody.includes('read-more-target') && (
          <label htmlFor="seo-text" className="read-more-trigger">
            <input
              type="checkbox"
              className="read-more-state"
              id="seo-text"
              onChange={this.handleSeoCopyView}
            />
            <BodyCopy
              className="read-more"
              component="p"
              fontFamily="secondary"
              fontWeight="semibold"
              textAlign="center"
              data-locator={getLocator('seo_readmore')}
              tabIndex="0"
            >
              {READ_MORE}
            </BodyCopy>
            <BodyCopy
              className="read-less"
              component="p"
              fontFamily="secondary"
              fontWeight="semibold"
              textAlign="center"
              data-locator={getLocator('seo_readless')}
              tabIndex="0"
            >
              {READ_LESS}
            </BodyCopy>
          </label>
        )}
      </BodyCopy>
    );
  }
}

SeoCopy.propTypes = {
  copyBody: PropTypes.string,
  className: PropTypes.string,
  copyTitle: PropTypes.string,
};

SeoCopy.defaultProps = {
  className: '',
  copyBody: '',
  copyTitle: '',
};

export default errorBoundary(withStyles(SeoCopy, style));
export { SeoCopy as SeoCopyVanilla };
